import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';

function Menu(props) {
  const {
    className, subMenuClassName, subMenuActiveClassName,
    headingClassName, itemClassName, menu,
    toggled, isActiveMenu, activateMenu,
  } = props;

  return (
    <div className={className}>
      {
        menu.href &&
        <span className={[headingClassName, isActiveMenu(get(menu, 'meta.name')) ? `${headingClassName}-active` : false].filter(v => v).join(' ')}>
          <Link to={menu.href}>{get(menu, 'meta.name')}</Link>
        </span>
      }
      {
        !menu.href &&
        <span // eslint-disable-line jsx-a11y/no-static-element-interactions
          className={headingClassName}
          onClick={toggled ? activateMenu(get(menu, 'meta.name')) : undefined}
          onKeyUp={toggled ? activateMenu(get(menu, 'meta.name')) : undefined}
          tabIndex={0} // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
          role={toggled ? 'button' : undefined}
        >
          {get(menu, 'meta.name')}
        </span>
      }
      <ul className={[subMenuClassName, isActiveMenu(get(menu, 'meta.name')) ? subMenuActiveClassName : false].filter(v => v).join(' ')}>
        {
          (menu.items || []).map(item => (
            <li
              key={item.title}
              className={itemClassName}
            >
              {
                item.href &&
                item.href.match(/^\//) &&
                <Link to={item.href}>{item.title}</Link>
              }
              {
                item.name &&
                <Link name={item.name}>{item.title}</Link>
              }
              {
                item.href &&
                !item.href.match(/^\//) &&
                <a href={item.href} target="_blank">{item.title}</a>
              }
            </li>
          ))
        }
      </ul>
    </div>
  );
}

Menu.propTypes = {
  className: PropTypes.string,
  subMenuClassName: PropTypes.string,
  subMenuActiveClassName: PropTypes.string,
  headingClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  menu: PropTypes.object,
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  toggled: PropTypes.bool,
};

Menu.defaultProps = {
  className: undefined,
  subMenuClassName: undefined,
  subMenuActiveClassName: undefined,
  headingClassName: undefined,
  itemClassName: undefined,
  menu: {},
  toggled: false,
};

export default Menu;



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/Navigation/Menu.js